import React, { useState, useEffect } from 'react';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';

const FilterPercentRange = ({
  field_name,
  setSelectedItems,
  addNode,
  updateNode,
  path,
 sliderValue,
 min,
 max
}) => {



  const [localSliderValue, setLocalSliderValue] = useState(sliderValue || [min, max]);

    useEffect(() => {
      setLocalSliderValue(sliderValue || [min, max]);
    }, [sliderValue, min, max]);


  const handleLocalSliderChange = (event, newValue) => {
    setLocalSliderValue(newValue); // Update local state immediately
  };

  // Commit the change to the global state once the user stops moving the slider
  const handleSliderChangeCommitted = (event, newValue) => {


    setSelectedItems((prev) => {
      const fullPath = [...path, { key: field_name, value: 0 }];
      var sliderField = prev[field_name] || [];
    
      if (sliderField.length === 0) {
        addNode(fullPath, { is_group: 0, "min": newValue[0], "max": newValue[1] });
      }
      else {
        updateNode(fullPath, { is_group: 0, "min": newValue[0], "max": newValue[1] }, field_name);
      }

      return ({
        ...prev,
        [field_name]: newValue,
      })
    });


  };



  return (
    <Box sx={{ width: '77%', margin: '0 auto' }}>
      <Slider
         sx={{
          "& .MuiSlider-valueLabel": {
              borderRadius: "5px",
              backgroundColor: "var(--main-color)",
              color: "#FFF",
              fontFamily: "Sfpro400",
              fontSize: "10px",
              letterSpacing: "1.2px",
              padding: "3px 12px",
          },
          "& .MuiSlider-thumb": {
              padding: "0.8px",
              outline: "1px solid rgb(180, 180, 180)",
              backgroundColor: "var(--main-color)",
              border: "2px solid rgb(255, 255, 255)",
              width: "9px",
              height: "9px",
          },
        }}
        value={localSliderValue}
        onChange={handleLocalSliderChange}
        onChangeCommitted={handleSliderChangeCommitted}
        min={min}
        max={max}
        valueLabelFormat={(value) => `%${value}`}
        valueLabelDisplay="on"
        className="products-sidebar-range"
        style={{ color: "#239DAB" }}

      />
    </Box>
  );
};

export default FilterPercentRange;
